export const MODULES = ["tasks", "extensions", "orders", "workflows", "team", "masters", "customers", "reports", "audit", "vendors"];

export const MODULE_LABELS = {
  tasks: "Tasks",
  extensions: "Extension Requests",
  orders: "Orders",
  workflows: "Workflow Templates",
  team: "Team Members",
  masters: "Masters",
  customers: "Customer Master",
  reports: "Reports",
  audit: "Audit Log",
  vendors: "Vendor Registry",
};

const DEFAULTS = {
  manager: MODULES,
  member: ["tasks", "extensions", "orders", "reports"],
};

export function effectiveModules(user) {
  if (!user) return [];
  if (user.role === "admin") return MODULES;
  const mods = Array.isArray(user.permissions) ? user.permissions : (DEFAULTS[user.role] || []);
  // Either Customer Master special permission implies view access to the module itself —
  // granting just "Add Customers" (add-only) should be enough to see/use Customer Master,
  // without also separately checking the "customers" module box.
  const special = user.special_permissions || [];
  if (!mods.includes("customers") && (special.includes("customer_add") || special.includes("customer_edit"))) {
    return [...mods, "customers"];
  }
  return mods;
}

export function hasModule(user, m) {
  if (!m) return true;
  return effectiveModules(user).includes(m);
}

// --- Special (non-module) permissions: granular action-level overrides ---
export const SPECIAL_PERMS = ["costing_override", "file_override", "store_receipts", "customer_add", "customer_edit", "job_responsibility_edit"];

export const SPECIAL_PERM_LABELS = {
  costing_override: "Edit Locked Costing Sheets",
  file_override: "Block / Unblock Files",
  store_receipts: "Material Receipts (Store) — record PO receipts without full Procurement access",
  customer_add: "Add Customers (Customer Master)",
  customer_edit: "Edit Customer Master Details (GST / address / notes)",
  job_responsibility_edit: "Change Job Responsibility on Existing Orders (in addition to Admin/Manager/HR)",
};

export function hasSpecialPermission(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  return Array.isArray(user.special_permissions) && user.special_permissions.includes(key);
}
